import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { HashLink } from 'react-router-hash-link';

import Logo from './ui-elements/Logo';
import OnSiteFeedback from './ui-elements/OnSiteFeedback';
import SourceList from './ui-elements/SourceList';

const Content = () => {
  return (
    <React.Fragment>
      <div className='bg-light' style={{flex: 1}}>
        <div className='d-flex flex-column justify-content-center'>
        <Container className='py-5'>
          <Row>
            <Col xs="12" md="7" className="text-center py-5 mt-5 mx-auto">
              <Logo size="lg" />
              <h3 className="">Wissen aus erster Hand</h3>
              <p className='lead mb-4'>Unsere Inhalte stammen von <strong>Profis</strong> aller politischer Richtungen. Sie bieten belastbare Informationen und <strong>direkte Einblicke</strong> in das politische Geschehen.</p>
            </Col>
          </Row>
          <Row className="">
            <Col xs="12" md="6" className="mx-auto pb-5 text-center">
              <p className=''>Unsere stetig wachsende Datenbank beinhaltet Publikationen zahlreicher politischer Akteure aus verschiedenen Richtungen. Sie bieten unterschiedliche Perspektiven auf politischen Themen.</p>
              <p className=''>Unsere Inhalte halten akademische Standards ein, sind auf einem professionellen Niveau geschrieben und bereiten politische Entwicklungen und deren Hintergründe verständlich auf.</p>
              <p className='font-weight-bold'>Wir verstehen uns als politisch neutral.</p>
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="6" className="mx-auto text-center pb-5">
              <h6 className="text-body">Quellen nach Typ</h6>
              <SourceList className="shadow-lg" legend />
            </Col>
          </Row>
          <Row>
            <Col xs="12" md="6" className="mx-auto text-center pb-5">
              <div className="bg-mid-gray p-4 my-5">
                <h6 className="text-body mb-4">Ausschluss von Inhalten</h6>
                <p className='text-body'>Offen menschenverachtende, rassistische sowie sexistische Inhalte werden nicht geduldet und führen zum Ausschluss aus unserer Datenbank.</p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>

    <div className="bg-mid-gray">
      <Container>
        <Row className="text-center pt-3">
          <Col>
            <small className="text-muted">Unsere offiziellen Medienpartner</small>
          </Col>
        </Row>
        <Row className='justify-content-center text-center pt-4 pb-5'>
          <Col xs="12" className="align-self-center px-5">
            <img src="/imgs/medienpartner/logo_100x80_lemond.png" alt="Le Monde Diplomatique" className="img-fluid mx-2 mx-md-3" style={{maxWidth: 100, height: 'auto', width: '25%'}}/>
            <img src="/imgs/medienpartner/logo_100x80_blaetter.png" alt="Blätter für deutsche und internationale Politik" className="img-fluid mx-2 mx-md-3" style={{maxWidth: 100, height: 'auto', width: '25%'}}/>
            <img src="/imgs/medienpartner/logo_100x80_agora.png" alt="agora42" className="img-fluid mx-2 mx-md-3" style={{maxWidth: 100, height: 'auto', width: '25%'}}/>
          </Col>
        </Row>
      </Container>
    </div>

    <div className="bg-secondary">
      <Container>
        <Col xs="12" md="6" className="mx-auto text-center py-5 mt-3 mb-5">
          <h4 className="text-white">Es fehlen für dich wichtige Quellen?</h4>
          <p className='lead text-white mb-5'>Wir geben unser Bestes um die für euch wichtigen Quellen schnell hinzuzufügen.</p>
          <OnSiteFeedback textarea_placeholder={"Was fehlt?"}/>
        </Col>
      </Container>
    </div>

  </React.Fragment>
  );
}

export default Content;



// WEBPACK FOOTER //
// ./src/components/Content.js